import React, { useContext, useState } from "react";
// React Bootstrap
import { Accordion, Card, Button } from "react-bootstrap";
// // Contexto
import { ModalContext } from "../../../context/modalContext";
import { AlertBoxContext } from "../../../context/alertBoxContext";
import { ConfirmModalContext } from "../../../context/confirmModalContext";

// Custom spinner
import CustomSpinner from "../../generic/CustomSpinner";
// Form

// Contexto
import VistaMisionExtra from "../vistas/VistaMisionExtra";
import { dateToString2 } from "../../../utils";
import MisionExtraForm from "../formularios/MisionExtraForm";

const MisionExtraModal = ({ accessLevel, key, misionExtra, handleDeleteMisionExtra, handlePutMisionExtra, ...props }) => {
  // Modal
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);
  // Custom spinner
  const [loading, setLoading] = useState(false);
  // Alertas
  const { addAlert } = useContext(AlertBoxContext);
  // Ventana de confirmación
  const { confirmModalSetShow, confirmModalSetTitle, confirmModalSetContent, confirmModalSetFunction } = useContext(ConfirmModalContext);
  
  //console.log(misionExtra)
    return (
    <div className="position-relative">
      <CustomSpinner animation={"border"} loading={loading} />

      <Accordion defaultActiveKey="1" className={"mb-2"}>
        <Card>
          <Card.Header>
            <Accordion.Toggle eventKey="0" as={Button} variant="link">
              {misionExtra.cargo}
            </Accordion.Toggle>

            {accessLevel > 2 && (
              <Button
                onClick={() => {
                  confirmModalSetShow(true);
                  confirmModalSetTitle(`Eliminar misión de la hermana (${misionExtra.cargo})`);
                  confirmModalSetContent(<p> {"¿Está seguro de que quiere eliminarla?"} </p>);
                  confirmModalSetFunction(() => {
                    handleDeleteMisionExtra(misionExtra);
                  });
                }}
                variant="outline-danger"
                size="sm"
                className="float-right mr-4"
              >
                Eliminar
              </Button>
            )}
            {(misionExtra?.endDate === null || dateToString2(new Date(misionExtra?.endDate)) > dateToString2(new Date())) && accessLevel > 2 && (
              <Button
                variant="outline-primary"
                size="sm"
                className="float-right mr-3"
                onClick={() => {
                  modalSetShow(true, "80%");
                  modalSetTitle("Editar misión de la hermana");
                  modalSetContent(<MisionExtraForm  misionExtra={misionExtra} submissionHandler={handlePutMisionExtra} />);
                }}
              >
                Editar
              </Button>
            )}
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <VistaMisionExtra misionExtra={misionExtra} />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default MisionExtraModal;
